// Function to extract levels, sub-levels, and sub-sub-levels
export function extractHierarchy(data) {
    const hierarchy = {};

    for (const level in data) {
        hierarchy[level] = {};
        for (const subLevel in data[level]) {
            if (subLevel === 'adm0') {
                hierarchy[level][subLevel] = []
            } else {
                hierarchy[level][subLevel] = Object.keys(data[level][subLevel]);
            }
        }
    }

    return hierarchy;
}

export function generateBandArray(value1, value5, value11) {
    return [
        {
            'band_1': 0,
            'band_5': 0,
            'band_11': 0,
        },
        {
            'band_1': value1,
            'band_5': value5,
            'band_11': value11,
        },
        {
            'band_1': 0,
            'band_5': 0,
            'band_11': 0,
        },
    ];
}

export function createADM1Object(adm1_max, pad = true) {
    const resultObject = {};

    adm1_max.forEach((item) => {
        const { ADM1_NAME, band_1, band_5, band_11 } = item;

        let bandData;

        if (pad) {
            bandData = generateBandArray(band_1, band_5, band_11);
        } else {
            bandData = {
                band_1,
                band_5,
                band_11,
            };
        }

        resultObject[ADM1_NAME] = bandData;
    });

    return resultObject;
}

